/* eslint-disable import/no-unresolved */
import { useReactiveVar } from '@apollo/client';

import AppBar from 'common/AppBar';
import LeftNav from 'common/LeftNavBar';
import { isAuthenticatedVar, leftNavigationItemsVar } from 'Apollo/config';
import Routes from 'routes';
import './layout.scss';

const Layout = () => {
    const isLoggedIn = useReactiveVar(isAuthenticatedVar);
    const navigationItems = useReactiveVar(leftNavigationItemsVar);
    return (
        <div className="nav-template template-theme-one">
            {isLoggedIn && <AppBar />}
            <div className="flex-fill">
                {navigationItems.length > 0 ? (
                    <>
                        <LeftNav className="a-menu" />
                        <div className="a-right-content">
                            <Routes />
                        </div>
                    </>
                ) : (
                    <Routes />
                )}
            </div>
            <div className="a-footer-wrapper">
                <div className="a-footer">
                    © 2025 PwC US. All rights reserved. PwC US refers to
                    the US group of member firms and may sometimes refer to the PwC network. Each member firm is a separate legal entity.
                    {' '}
                    {'\u00A0'}
                    <a target="_blank" rel="noopener noreferrer" href="https://www.pwc.com/us/en/site/privacy.html">Privacy Statement</a>
                </div>
            </div>
        </div>
    );
};

export default Layout;
